import React from 'react'

import { YStack } from 'tamagui'

import { Button } from '@newComponents/Button/Button'
import { Text } from '@newComponents/Text'

export const UnsavedChangesDialog = ({
  onSaveAndLeave,
  onDiscard,
  onCancel,
}: {
  onSaveAndLeave: () => void
  onDiscard: () => void
  onCancel: () => void
}) => {
  return (
    <YStack
      position='fixed'
      top={0}
      left={0}
      right={0}
      bottom={0}
      backgroundColor='rgba(0, 0, 0, 0.4)'
      alignItems='center'
      justifyContent='center'
      zIndex={200_000}
    >
      <YStack
        backgroundColor='$grey0'
        borderRadius='$6'
        padding='$6'
        gap='$4'
        maxWidth={420}
        width='90%'
        style={{
          boxShadow:
            'rgba(27, 19, 64, 0.5) 0px 4px 8px -4px, rgba(27, 19, 64, 0.3) 0px 5px 26px -7px',
        }}
      >
        <Text fontSize='$6' fontWeight='$6'>
          You have unsaved changes
        </Text>
        <Text fontSize='$4' color='$grey8'>
          Your changes will be lost if you leave without saving.
        </Text>
        <YStack gap='$3' paddingTop='$2'>
          <Button onPress={onSaveAndLeave}>
            <Button.Text>Save & Leave</Button.Text>
          </Button>
          <Button red onPress={onDiscard}>
            <Button.Text>Discard</Button.Text>
          </Button>
          <Button secondary onPress={onCancel}>
            <Button.Text>Cancel</Button.Text>
          </Button>
        </YStack>
      </YStack>
    </YStack>
  )
}
